/**
 * Bosh sahifa ichidagi silliq o'tish: «Bosh sahifa» — yuqoriga, «Yangiliklar» —
 * yangiliklar blokiga. Boshqa sahifadan bosilsa oddiy marshrut ishlaydi
 * (`/` yoki `/#yangiliklar`), scroll'ni `PublicLayout` dagi `ScrollToTop` bajaradi.
 */
import { NEWS_ANCHOR } from "@/shared/lib/sectionRoutes";

export type HomeSpot = "top" | "news";

export function scrollHome(spot: HomeSpot) {
  const target = spot === "news" ? document.getElementById(NEWS_ANCHOR) : null;
  if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
  else window.scrollTo({ top: 0, behavior: "smooth" });
}
